<!--
 * @Author: Matt.Xu matt.xu@gtechdigi.com
 * @Date: 2024-06-26 14:20:10
 * @LastEditors: Matt.Xu matt.xu@gtechdigi.com
 * @LastEditTime: 2024-11-12 16:55:20
 * @FilePath: /ua-cnbs-mall/src/components/Coupons/CouponSelect.vue
 * @Description: 优惠券选择器，多选版
 * 
 * Copyright (c) 2024 by 佳应科技, All Rights Reserved. 
-->
<template>
  <div
    :class="[
      'ua-coupon-select',
      { 'is-focus': isFocus },
      { 'offset-placeholder': offsetPlaceholder },
      { 'is-disabled': disabled },
      { 'is-nonselectable': !hasSelectable }
    ]"
  >
    <div class="ua-coupon-select__input-wrapper" @click="onClick">
      <div v-if="labelable" class="ua-coupon-select__placeholder">
        {{ offsetPlaceholder ? label : placeholder }}
      </div>
      <Input
        class="ua-coupon-select__input"
        :value="couponStrs"
        :placeholder="labelable ? undefined : placeholder"
        readonly
      ></Input>
      <div class="ua-coupon-select__dropdown-icon__wrapper">
        <div class="ua-coupon-select__dropdown-icon">
          <div v-if="dropdownVisible" class="iconfont icon-a-16-1px-up-s"></div>
          <div v-else class="iconfont icon-a-16-1px-down-s"></div>
        </div>
      </div>
    </div>
    <Dropdown
      ref="dropdownRef"
      class="ua-coupon-select__dropdown"
      placement="bottom-start"
      trigger="click"
      :disabled="disabled"
      @visible-change="onDropdownVisible"
    >
      <div class="ua-coupon-select__dropdown-trigger"></div>
      <template #dropdown>
        <DropdownMenu
          slot="dropdown"
          class="ua-coupon-select__dropdown-menu"
          :visible-arrow="false"
          :append-to-body="false"
          :offset="-1"
        >
          <div
            :style="{ width: triggerWidth + 'px' }"
            class="ua-coupon-select__dropdown-menu-inner"
          >
            <template v-for="coupon in couponList">
              <div
                :key="coupon.couponCode"
                :class="[
                  'ua-coupon-select__dropdown-menu-item',
                  { 'is-checked': Boolean(checkIndex(coupon) + 1) }
                ]"
                @click="onCheck(checkIndex(coupon), coupon)"
              >
                <div class="ua-coupon-select__dropdown-menu-item__content">
                  <div class="ua-coupon-select__dropdown-menu-item__title text-overflow">
                    {{ coupon.activityName }}
                  </div>
                  <div class="ua-coupon-select__dropdown-menu-item__subtitle">
                    {{ dayjs(coupon.validStartTime).format('YYYY.MM.DD HH:mm') }}-{{
                      dayjs(coupon.validEndTime).format('YYYY.MM.DD HH:mm')
                    }}
                  </div>
                </div>
                <div class="ua-coupon-select__dropdown-menu-item__right">
                  <Checkbox :value="Boolean(checkIndex(coupon) + 1)"></Checkbox>
                </div>
              </div>
            </template>
            <template v-if="disabledCouponList.length">
              <Divider></Divider>
              <div class="ua-coupon-select__dropdown-menu__label">以下优惠券不可用：</div>
              <template v-for="coupon in disabledCouponList">
                <div
                  :key="coupon.couponCode"
                  :class="['ua-coupon-select__dropdown-menu-item', { 'is-disabled': true }]"
                  @click="onCheck(checkIndex(coupon), coupon)"
                >
                  <div class="ua-coupon-select__dropdown-menu-item__content">
                    <div class="ua-coupon-select__dropdown-menu-item__title text-overflow">
                      {{ coupon.activityName }}
                    </div>
                    <div class="ua-coupon-select__dropdown-menu-item__subtitle">
                      {{ dayjs(coupon.validStartTime).format('YYYY.MM.DD HH:mm') }}-{{
                        dayjs(coupon.validEndTime).format('YYYY.MM.DD HH:mm')
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </DropdownMenu>
      </template>
    </Dropdown>

    <!-- <template v-else>
      <Popup ref="popupRef" title="使用优惠券/码" @visible-change="onPopupVisible">
        <div class="ua-coupon-select__popup-view">
          <template v-for="(coupon, index) in couponList">
            <CouponOption
              :key="index"
              :check="Boolean(checkIndex(coupon) + 1)"
              :coupon-data="coupon"
              :disabled="!coupon.isReward"
              @click="onCheck(checkIndex(coupon), coupon)"
              @showRule="onShowRule(coupon)"
            ></CouponOption>
          </template>
        </div>
      </Popup>
    </template> -->
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Input, Dropdown, DropdownMenu, Divider } from 'element-ui';
// import { componentsCommon } from '@speedshop/template';
// import Popup from '../Popup/index.vue';
import Checkbox from './Checkbox.vue';
// import CouponOption from './CouponOption.vue';
// import CouponSelectionView from './CouponSelectionView.vue';

export default {
  name: 'CouponSelect',
  components: {
    Input,
    Dropdown,
    DropdownMenu,
    Checkbox,
    Divider
    // CouponSelectionView,
    // Popup,
    // CouponOption
  },
  // mixins: [componentsCommon],
  model: {
    prop: 'value',
    event: 'update:value'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    couponList: {
      type: Array,
      default: () => []
    },
    disabledCouponList: {
      type: Array,
      default: () => []
    },
    labelable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dayjs,
      dropdownVisible: false,
      // popupVisible: false,
      label: '优惠券',
      triggerWidth: 0
    };
  },
  computed: {
    isFocus() {
      return this.dropdownVisible;
    },
    couponStrs() {
      return this.value
        .map(code => {
          const item = this.couponList.find(i => i.couponCode === code);
          return item?.activityName || code;
        })
        .join(';');
    },
    hasSelectable() {
      return this.couponList.length;
    },
    placeholder() {
      return this.hasSelectable ? '请选择优惠券' : '暂无可用优惠券';
    },
    offsetPlaceholder() {
      return this.isFocus || this.couponStrs.length;
    }
  },
  methods: {
    onDropdownVisible(v) {
      this.dropdownVisible = v;
    },
    // onPopupVisible(v) {
    //   this.popupVisible = v;
    // },
    checkIndex(item) {
      return this.value.findIndex(code => code === item.couponCode);
    },
    onCheck(index, item) {
      const selection = [...this.value];
      if (index > -1) {
        selection.splice(index, 1);
      } else {
        selection.push(item.couponCode);
      }
      this.$emit('update:value', selection);
      this.$emit('change', selection);
    },
    // showPopper() {
    //   if (this.isMobile) {
    //     this.$refs.popupRef.show();
    //   } else {
    //     this.$refs.dropdownRef.show();
    //   }
    // },
    // hidePopper() {
    //   if (this.isMobile) {
    //     this.$refs.popupRef.hide();
    //   } else {
    //     this.$refs.dropdownRef.hide();
    //   }
    // },
    onClick() {
      if (this.hasSelectable) {
        this.triggerWidth =
          document.querySelector('.ua-coupon-select__dropdown-trigger')?.getBoundingClientRect()
            ?.width || 0;
        if (this.isFocus) {
          this.$refs.dropdownRef.hide();
        } else {
          this.$refs.dropdownRef.show();
        }
      }
      this.$emit('click');
    }
  }
};
</script>
<style lang="scss">
#page-view
  .el-form
  .el-form-item:not(:has(> .el-form-item__label))
  .ua-coupon-select
  .ua-coupon-select__input
  .el-input__inner::placeholder {
  color: var(--secondary-color-ua-cool-grey-02) !important;
}
</style>
<style lang="scss" scoped>
::v-deep {
  &.el-dropdown {
    display: block;
  }
  &.el-popper[x-placement^='bottom'] {
    margin-top: 4px;
  }
  &.el-popper {
    padding: 0;
    border: 1px solid var(--line-color-line-grey-01);
  }
  &.el-divider {
    margin: 12px 20px;
    background-color: var(--line-color-line-grey-02);
  }
  &.el-divider--horizontal {
    width: auto;
  }
  .el-input--medium {
    height: calc(var(--size) - 2px);
  }
  .ua-coupon-select__input .el-input__inner {
    height: 100% !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 100%;
    border: none !important;
    background-color: transparent;
    padding: 0px 10px 0 20px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: var(--main-color-ua-dark-grey);
    &::placeholder {
      color: var(--secondary-color-ua-cool-grey-03) !important;
    }
  }
}
.ua-coupon-select {
  cursor: pointer;
  background-color: var(--main-color-ua-white);
  position: relative;
  --size: var(--input-medium-height);
  height: var(--size);
  // &.is-mobile {
  //   width: auto;
  // }
  &.is-focus {
    .ua-coupon-select__input-wrapper {
      border-color: var(--main-color-ua-dark-grey);
    }
  }
  &.offset-placeholder {
    .ua-coupon-select__placeholder {
      top: 0;
      color: var(--main-color-ua-dark-grey);
      &::after {
        content: '';
        height: 1px;
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        z-index: -1;
        transform: translateY(calc(-50% + 0.5px));
        background-color: #fff;
      }
    }
  }
  &.is-nonselectable {
    background-color: var(--main-color-ua-light-grey);
  }
  &.is-disabled {
    // .ua-coupon-select__dropdown {
    //   pointer-events: none;
    // }
  }
}
.ua-coupon-select__placeholder {
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  height: 20px;
  color: var(--secondary-color-ua-cool-grey-03);
  padding: 0 8px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ua-coupon-select__dropdown {
  width: 100%;
}
.ua-coupon-select__input-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  border-color: var(--secondary-color-ua-cool-grey-02);
  border-width: 1px;
  border-style: solid;
  border-radius: 1px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ua-coupon-select__dropdown-icon__wrapper {
  padding: 0px 20px 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ua-coupon-select__dropdown-icon {
  width: 16px;
  height: 16px;
  color: var(--main-color-ua-dark-grey);
  display: flex;
  justify-content: center;
  align-items: center;
}
.ua-coupon-select__dropdown-menu {
  // width: 335px;
  padding: 20px 0;
  left: 0 !important;
}
.ua-coupon-select__dropdown-menu-inner {
  max-height: 363px;
  // padding: 20px 0;
  overflow-y: auto;
}
.ua-coupon-select__dropdown-menu__label {
  padding: 4px 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--secondary-color-ua-cool-grey-03);
}
.ua-coupon-select__dropdown-menu-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  &.is-checked {
    .ua-coupon-select__dropdown-menu-item__title {
      color: var(--main-color-ua-dark-grey);
      // font-family: 'Neue Plak Black' !important;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    }
    .ua-coupon-select__dropdown-menu-item__subtitle {
      color: var(--main-color-ua-dark-grey);
    }
  }
  &.is-disabled {
    pointer-events: none;
    .ua-coupon-select__dropdown-menu-item__title {
      color: var(--secondary-color-ua-cool-grey-02);
    }
    .ua-coupon-select__dropdown-menu-item__subtitle {
      color: var(--secondary-color-ua-cool-grey-02);
    }
    .ua-coupon-select__dropdown-menu-item__right {
      display: none;
    }
  }
}
.ua-coupon-select__dropdown-menu-item__content {
  min-width: 0;
  flex-grow: 1;
}
.ua-coupon-select__dropdown-menu-item__right {
  margin-left: 20px;
}
.ua-coupon-select__dropdown-menu-item__title {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--secondary-color-ua-cool-grey-04);
}
.ua-coupon-select__dropdown-menu-item__subtitle {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--secondary-color-ua-cool-grey-03);
}
.ua-coupon-select__popup {
  // padding: 20px 20px 32px;
}
.ua-coupon-select__popup-view {
  height: calc(620px - 58px);
  padding: 0 20px;
  overflow-y: auto;
  padding-bottom: 32px;
}
.ua-coupon-option {
  &:not(:last-child) {
    margin-bottom: 8px;
  }
}
</style>
